import { styled } from 'styled-components';
import { tk, Skeleton } from '@sunwebgroup/ui-components';

const ImageElementSkeleton = styled(Skeleton)`
  width: 100%;
  height: 100%;
  @media ${tk('mq_tablet')} {
    border-radius: ${tk('radius_large')};
    &:nth-child(n + 6) {
      display: none;
    }
  }

  &:nth-child(n + 4) {
    display: none;
  }

  object-fit: cover;
  display: block;
`;

export const ImageElementButton = styled.button`
  position: relative;
`;

export const MainGridWrapper = styled.li`
  display: block;
  height: 100%;
  width: 100%;

  &:first-child {
    grid-column: span 2;
    @media ${tk('mq_tablet')} {
      grid-row: span 2;
    }
  }

  &:nth-child(n + 4) {
    display: none;

    @media ${tk('mq_desktop_sm')} {
      display: block;
    }
  }

  &:nth-child(2),
  &:nth-child(3) {
    @media ${tk('mq_tablet')} {
      grid-column: span 2;
    }
    @media ${tk('mq_desktop_sm')} {
      grid-column: span 1;
    }
  }

  ${ImageElementButton} {
    display: block;
    height: 100%;
    width: 100%;
  }
`;

const Wrapper = styled.ol`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, minmax(0, 1fr));
  height: 350px;
  list-style: none;
  margin-left: unset;
  margin-bottom: ${tk('spacing_2xl')};

  /**
   This is here to hide the "old" collection label in the PDP when the react
   version of the gallery is present.

   TODO: Remove after all PDP is migrated to react
   */
  z-index: 1;
  position: relative;
  /* **** */

  @media ${tk('mq_tablet')} {
    gap: ${tk('spacing_sm')};
    grid-gap: ${tk('spacing_sm')};
    grid-template-columns: repeat(4, 1fr);
    height: 425px;
    margin-bottom: unset;
  }
`;

export function GalleryLoading() {
  return (
    <Wrapper className="accommodation-carousel">
      {[...Array(5)].map((_, i) => (
        <MainGridWrapper key={i}>
          <ImageElementButton onClick={() => null}>
            <ImageElementSkeleton />
          </ImageElementButton>
        </MainGridWrapper>
      ))}
    </Wrapper>
  );
}
